import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AppointmentTable from "../AppointmentTable";
import AppontmentCalender from "../AppontmentCalender";
import { getPathSegment } from "../../utils/navigation";

export default function Index({
  activeView,
  selectedType,
  setFilteredFollowUpAppointment,
  filteredFollowUpAppointment,
  setSelectedRows,
  selectedRows,
  sortClicked,
  onVisibleDataChange,
}) {
  const { loading, error } = useSelector((state) =>
    state.GET_FOLLOW_UP_APPOINTMENT
  );
  const [updatedData, setUpdatedData] = useState([]);
  const aid = getPathSegment(2);

  useEffect(() => {
    if (selectedType === "upcoming" && !aid.includes("date")) {
      let d = Object.values(filteredFollowUpAppointment || {}).flat();
      setUpdatedData(
        d.filter(
          (item) =>
            item.status !== "COMPLETED" &&
            new Date(`${item.date}T${item.startTime}`) >= new Date()
        )
      );
    } else if (aid === "incomplete") {
      let clientData = Object.values(filteredFollowUpAppointment || {}).flat();
      let filter = clientData.filter(
        (item) => item.url === null && item.status === "IN_COMPLETE"
      );
      setUpdatedData(filter);
    } else if (aid === "did_not_joined") {
      let clientData = Object.values(filteredFollowUpAppointment || {}).flat();
      let filter = clientData.filter(
        (item) =>
          new Date(`${item.date}T${item.startTime}`) <= new Date() &&
          item.status === "SCHEDULED"
      );
      setUpdatedData(filter);
    } else if (aid === "past") {
      let d = Object.values(filteredFollowUpAppointment || {}).flat();
      setUpdatedData(d.filter((item) => item.status === "COMPLETED"));
    } else if (aid === "new_user") {
      const allAppointments = Object.values(filteredFollowUpAppointment || {}).flat();

      const userAppointmentsMap = {};
      allAppointments.forEach((app) => {
        if (!userAppointmentsMap[app.uid]) {
          userAppointmentsMap[app.uid] = [];
        }
        userAppointmentsMap[app.uid].push(app);
      });

      const firstTimeUsers = [];

      for (const [, apps] of Object.entries(userAppointmentsMap)) {
        const scheduledCount = apps.filter(
          (app) => app.status === "SCHEDULED"
        ).length;
        const completedCount = apps.filter(
          (app) => app.status === "COMPLETED"
        ).length;

        if (
          (scheduledCount >= 1 && completedCount === 0) ||
          (completedCount === 1 && scheduledCount === 0)
        ) {
          firstTimeUsers.push(apps);
        }
      }

      setUpdatedData(firstTimeUsers);
    } else if (aid === "returning") {
      let userAppointments = {};
      let appointmentsByDate = filteredFollowUpAppointment;
      Object.values(appointmentsByDate)
        .flat()
        .forEach((app) => {
          if (!userAppointments[app.uid]) {
            userAppointments[app.uid] = [];
          }
          userAppointments[app.uid].push(app);
        });

      const returningCustomers = [];

      Object.entries(userAppointments).forEach(([uid, appointments]) => {
        const hasCompleted = appointments.some(
          (app) => app.status === "COMPLETED"
        );

        if (hasCompleted) {
          returningCustomers.push(appointments);
        }
      });

      setUpdatedData(returningCustomers);
    } else if (aid.includes("date")) {
      const date = aid.split("=")[1];
      let d = Object.values(filteredFollowUpAppointment || {}).flat();
      setUpdatedData(
        d.filter((item) => item.date === date && item.status === "SCHEDULED")
      );
    } else {
      let d = Object.values(filteredFollowUpAppointment || {}).flat();
      setUpdatedData(
        d.filter(
          (item) => new Date(`${item.date}T${item.startTime}`) <= new Date()
        )
      );
    }
  }, [selectedType, filteredFollowUpAppointment, aid]);

  return (
    <>
      {activeView === "grid" ? (
        <AppointmentTable
          selectedType={selectedType}
          loading={loading}
          error={error}
          data={updatedData}
          setSelectedRows={setSelectedRows}
          selectedRows={selectedRows}
          sortClicked={sortClicked}
          onVisibleDataChange={onVisibleDataChange}
        />
      ) : (
        <AppontmentCalender
          selectedType={selectedType}
          loading={loading}
          error={error}
          data={updatedData}
        />
      )}
    </>
  );
}
